import React from 'react';
import './FutureVision.css';

const FutureVision = () => {
  const visionAreas = [
    {
      id: 1,
      icon: '🏢',
      title: 'High-Rise Apartments',
      description: 'Modern vertical communities with world-class amenities, smart living spaces, and sustainable urban architecture.'
    },
    {
      id: 2,
      icon: '🏰',
      title: 'Luxury Villas',
      description: 'Bespoke architectural marvels combining elegance, privacy, and premium lifestyle in curated locations.'
    },
    {
      id: 3,
      icon: '🏡',
      title: 'Independent Homes',
      description: 'Personalized living spaces designed for families seeking autonomy, space, and architectural freedom.'
    }
  ];

  const expertise = [
    { year: '11+', label: 'Years of Expertise', desc: 'Industry experience in DTCP & HMDA farm lands' },
    { value: '800+', label: 'Acres Developed', desc: 'Successfully transformed landscapes' },
    { value: '10', label: 'Completed Projects', desc: 'In residential plot development' }
  ];

  return (
    <section className="future-vision">
      {/* Eyebrow */}
      <div className="vision-eyebrow">
        <div className="eyebrow-line"></div>
        <span className="eyebrow-text">What's Next</span>
        <div className="eyebrow-line"></div>
      </div>

      {/* Main Heading */}
      <h1 className="vision-title">
        Our <em>Future Dream</em>
      </h1>

      {/* Intro */}
      <div className="vision-intro">
        <p>
          With 11 years of proven expertise in the real estate industry, Swayam Homes has built an unshakeable 
          foundation in DTCP and HMDA farm lands and plot development. Today, we stand at the threshold of evolution.
        </p>
      </div>

      {/* Experience Foundation */}
      <div className="experience-foundation">
        <h2>Our Foundation</h2>
        <div className="foundation-grid">
          {expertise.map((item) => (
            <div key={item.label} className="foundation-item">
              <div className="foundation-stat">{item.year || item.value}</div>
              <div className="foundation-label">{item.label}</div>
              <p className="foundation-desc">{item.desc}</p>
            </div>
          ))}
        </div>
      </div>

      {/* Vision Expansion */}
      <div className="vision-expansion">
        <div className="expansion-header">
          <h2>The Evolution: From Plots to Complete Communities</h2>
          <p className="expansion-subtitle">
            Our future vision encompasses a comprehensive expansion into diverse property categories, 
            establishing Swayam Homes as a complete real estate and construction powerhouse.
          </p>
        </div>

        <div className="vision-cards">
          {visionAreas.map((area) => (
            <div key={area.id} className="vision-card">
              <div className="vision-icon">{area.icon}</div>
              <h3 className="vision-card-title">{area.title}</h3>
              <p className="vision-card-desc">{area.description}</p>
              <div className="vision-card-footer">
                <span className="coming-soon">Coming Soon</span>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* All-Rounder Positioning */}
      <div className="allrounder-section">
        <div className="allrounder-content">
          <h2>Building an All-Rounder Ecosystem</h2>
          <p className="allrounder-subtitle">
            From starter plots to luxury apartments, independent villas to high-rise communities— 
            Swayam Homes is evolving into a holistic real estate and construction partner for every lifestyle.
          </p>

          <div className="allrounder-features">
            <div className="feature-item">
              <div className="feature-number">1</div>
              <h4>Diverse Portfolio</h4>
              <p>Property solutions across all segments—plots, apartments, villas, and independent homes.</p>
            </div>

            <div className="feature-item">
              <div className="feature-number">2</div>
              <h4>Quality & Trust</h4>
              <p>Every project built on the same principles: customer-centric design, premium quality, and integrity.</p>
            </div>

            <div className="feature-item">
              <div className="feature-number">3</div>
              <h4>Innovation</h4>
              <p>Smart design, sustainable practices, and modern architecture across all development categories.</p>
            </div>

            <div className="feature-item">
              <div className="feature-number">4</div>
              <h4>Lifetime Partnership</h4>
              <p>From land purchase to home ownership—we're with you at every stage of your real estate journey.</p>
            </div>
          </div>
        </div>

        <div className="allrounder-visual">
          <div className="vision-placeholder">
            <span>Complete Real Estate Solutions</span>
          </div>
        </div>
      </div>

      {/* Trust & Assets */}
      <div className="trust-section">
        <h2>Built on Customer Assets & Trust</h2>
        <div className="trust-grid">
          <div className="trust-card">
            <div className="trust-icon">🤝</div>
            <h3>Customer-First Philosophy</h3>
            <p>
              Every expansion aligns with customer needs and aspirations. Your dreams shape our future roadmap.
            </p>
          </div>

          <div className="trust-card">
            <div className="trust-icon">🏆</div>
            <h3>Proven Track Record</h3>
            <p>
              11 years of delivering exceptional plot developments builds the confidence for our next chapter.
            </p>
          </div>

          <div className="trust-card">
            <div className="trust-icon">💼</div>
            <h3>Asset Development</h3>
            <p>
              We don't just build properties—we create lasting wealth and legacy assets for our customers.
            </p>
          </div>

          <div className="trust-card">
            <div className="trust-icon">🌟</div>
            <h3>Excellence in Execution</h3>
            <p>
              From concept to completion, we bring the same dedication and precision to every project category.
            </p>
          </div>
        </div>
      </div>

      {/* Vision Statement */}
      <div className="vision-statement">
        <p className="vision-quote">
          "Swayam Homes is not just expanding its portfolio—we're expanding possibilities. 
          From the ground we've cultivated for over a decade, we're building toward a future where 
          Swayam is synonymous with quality, trust, and complete real estate excellence."
        </p>
        <p className="vision-author">— The Swayam Homes Family</p>
      </div>

      {/* CTA */}
      <div className="vision-cta">
        <h2>Be Part of Our Journey</h2>
        <p>Stay tuned for exciting announcements about our new ventures in apartments, villas, and independent homes.</p>
        <button className="cta-button">Join Our Future</button>
      </div>
    </section>
  );
};

export default FutureVision;
